import { Button, Modal, Typography } from "antd";
import React, { useState } from "react";
import { QrcodeOutlined } from "@ant-design/icons";
import colors from "constants/colors";
import { QRCode } from "react-qrcode-logo";
import BLHeads from "assets/images/bindeleddetLogo/BL_heads.png";

const { Text, Title } = Typography;

interface Props {
  eventId: number;
}

const QRCodeEvent: React.FC<Props> = ({ eventId }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button onClick={() => setOpen(true)} type="primary" title="Last ned QR-kode" style={{ margin: "0 5px" }}>
        <QrcodeOutlined />
      </Button>
      <Modal
        title={<Title level={4}>QR-kode</Title>}
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width="auto"
        footer={null}
        bodyStyle={{ overflowY: "auto", textAlign: "center", maxWidth: "400px" }}
      >
        <QRCode
          fgColor={colors.primary}
          logoImage={BLHeads}
          logoWidth={40}
          removeQrCodeBehindLogo
          ecLevel="Q"
          qrStyle="dots"
          eyeRadius={5}
          value={`https://bindeleddet.no/events/${eventId}}`}
          id="qrCode"
        />
        <br />
        <Text>
          QR-koden inneholder påmeldingslenken til dette arrangementet for studenter, og kan brukes på plakater og
          lignende.
        </Text>
      </Modal>
    </>
  );
};

export default QRCodeEvent;
